import { useEffect, useState } from "react";
import { COOKIE } from "@/constants/testIds";

export function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("preshh_cookie_consent")) setShow(true);
  }, []);
  const decide = (v) => { localStorage.setItem("preshh_cookie_consent", v); setShow(false); };
  if (!show) return null;
  return (
    <div data-testid={COOKIE.banner}
      className="fixed bottom-4 md:bottom-6 inset-x-4 md:inset-x-auto md:right-6 md:max-w-md z-50 bg-[#0a0a0a] border border-white/15 rounded-2xl p-5 shadow-2xl">
      <p className="text-sm text-white/80 leading-relaxed">
        We use essential cookies for the store and optional analytics to improve your experience. Your choice, your data.
      </p>
      <div className="flex gap-2 mt-4">
        <button data-testid={COOKIE.accept} onClick={() => decide("all")}
          className="flex-1 bg-[#00B5D8] hover:bg-[#009AB8] text-black font-semibold rounded-full py-2 text-sm transition-colors">Accept all</button>
        <button data-testid={COOKIE.reject} onClick={() => decide("essential")}
          className="flex-1 bg-white/10 hover:bg-white/15 text-white font-semibold rounded-full py-2 text-sm transition-colors">Essential only</button>
      </div>
    </div>
  );
}
